import { forwardRef, useImperativeHandle, useContext, useEffect, useRef, useState } from "react";
import { FormUtility } from "../../Utility/FormUtility";
import Input from "../../Form/Input";
import Select from "../../Form/Select";
import ToastContext from "../../../contexts/toast";
import StatusContext from "../../../contexts/status";
import { presaVisioneActions } from "../../../redux/PresaVisione";
import { useDispatch } from "react-redux";
import { UserService } from "../../../services/UserService";
import { Utente } from "../../../models/Utente";
import { DatiUtenza } from "../../../models/DatiUtenza";
import Checkbox from "../../Form/Checkbox";
import { useNavigate, useLocation } from "react-router-dom";
import AlertMessage from "../../Utility/Alert/AlertMessage";
import province from "../../Utility/json/province";
import tuttiComuni from "../../Utility/json/tuttiComuni";
import { NazioneService } from "../../../services/NazioneService";

const DatiUtente = forwardRef((props, ref) => {

  const masks = {
    maskCap: '00000', maskTel:'0000000000'
  };

  const [validate, setValidate] = useState(false);
  const [inputErrors, setInputErrors] = useState([]);
  const [inSave, setInSave] = useState(false);
  const [utente, setUtente] = useState(new Utente());
  const [datiUtente, setDatiUtente] = useState(new DatiUtenza());
  const [stati, setStati] = useState(null);
  const [cittadinanze, setCittadinanze] = useState(null);
  const [provinceResidenza, setProvinceResidenza] = useState(null);
  const [provinceDomicilio, setProvinceDomicilio] = useState(null);
  const [comuniResidenza, setComuniResidenza] = useState(null);
  const [comuniDomicilio, setComuniDomicilio] = useState(null);
  const [dirty, setDirty] = useState(false);

  const toastContext = useContext(ToastContext);
  const statusContext = useContext(StatusContext);
  const userService = new UserService();
  const nazioneService = new NazioneService();
  const utility = new FormUtility();
  const navigation = useNavigate();
  const dispatch = useDispatch();
  const formRef = useRef(null);

  const prefixes = utility.getPrefissi();

  const regExprEmail = '^[a-zA-Z0-9._%+\\-]+@[a-zA-Z0-9.\\-]+\\.[a-zA-Z]{2,}$';
  const regExprCellulare = /^3\d{9}$/;

  useImperativeHandle(ref, () => ({
    checkForm() {
      const validity = formRef.current.checkValidity();
      if (!validity || !validateTelefono(datiUtente.telefono)) {
        setFormErrors(false, !validateTelefono(datiUtente.telefono) ? 'telefono' : null);
      }
      return validity;
    }
  }));

  useEffect(() => {
    userService
      .getDatiUtente()
      .then((user) => {
        setUtente(user);
        const datiUtenza = props.data?.statoRichiesta === 'PRESENTATA' ? props.data : user.datiUtente;
        setDatiUtente(datiUtenza);

        if (datiUtenza.statoResidenza === 1) {
          const comuni = [ ...tuttiComuni ].filter(el => el.denominazione_provincia === datiUtenza.provRes);
          setComuniResidenza(comuni.sort((a, b) => a.denominazione.localeCompare(b.denominazione)));
          props.propagateComuni && props.propagateComuni([ ...comuni ]);
        } else {
          setComuniResidenza([]);
        }

        if (datiUtenza.statoDomicilio === 1) {
          const comuni = [ ...tuttiComuni ].filter(el => el.denominazione_provincia === datiUtenza.provDom);
          setComuniDomicilio(comuni.sort((a, b) => a.denominazione.localeCompare(b.denominazione)));
        } else {
          setComuniDomicilio([]);
        }
      });

    const provinces = [ ...province ].sort((a, b) => a.denominazione_provincia.localeCompare(b.denominazione_provincia));
    setProvinceResidenza(provinces);
    setProvinceDomicilio(provinces);

    if (!('nazioni' in props)) {
      nazioneService.getAll().then((resp) => {
        const italia = resp.find((nazione) => nazione.nome === "Italia");

        resp.sort((a, b) => (a.nome.localeCompare(b.nome)));
        resp = resp.filter((nazione) => nazione.nome !== "Italia");
        resp.unshift(italia);
        setStati([...resp]);

        resp.sort((a, b) => (a.cittadinanza.localeCompare(b.cittadinanza)));
        resp = resp.filter((nazione) => nazione.nome !== "Italia");
        resp.unshift(italia);
        setCittadinanze([...resp]);
      });
    }

    return () => {
      statusContext.removeEvent("onbeforeunload");
    };
  }, []);

  useEffect(() => {
    if (props.nazioni) {
      let nazioni = [ ...props.nazioni ];
      const italia = nazioni.find((nazione) => nazione.nome === "Italia");

      nazioni.sort((a, b) => (a.nome.localeCompare(b.nome)));
      nazioni = nazioni.filter((nazione) => nazione.nome !== "Italia");
      nazioni.unshift(italia);
      setStati([...nazioni]);

      nazioni.sort((a, b) => (a.cittadinanza.localeCompare(b.cittadinanza)));
      nazioni = nazioni.filter((nazione) => nazione.nome !== "Italia");
      nazioni.unshift(italia);
      setCittadinanze([...nazioni]);
    };
  }, [props.nazioni]);

  useEffect(() => {
    if (dirty) {
      props.onChangedValue && props.onChangedValue();
    }
  }, [dirty]);

  const getComuni = (provincia, type) => {
    const comuni = [ ...tuttiComuni ].filter(el => el.denominazione_provincia === provincia).sort((a, b) => a.denominazione.localeCompare(b.denominazione));
    switch (type) {
      case "Residenza":
        setComuniResidenza(comuni);
        props.propagateComuni && props.propagateComuni([ ...comuni ]);
        break;
      case "Domicilio":
        setComuniDomicilio(comuni);
        break;
      default:
        break;
    }
  };

  const checkFlagIsPresent = () => {
    if (datiUtente.domicilioComeResidenza) {
      datiUtente.domicilioComeResidenza = null;
      datiUtente["statoDomicilio"] = null;
      datiUtente["provDom"] = null;
      datiUtente["comuneDomicilio"] = null;
      datiUtente["viaDomicilio"] = null;
      datiUtente["civicoDomicilio"] = null;
      datiUtente["capDomicilio"] = null;
    }
  };

  const onChangeFlagDomicilioAsResidenza = (event) => {
    const target = event.target;
    datiUtente[target.name] = target.checked;

    datiUtente["statoDomicilio"] = target.checked
      ? datiUtente["statoResidenza"]
      : null;
    datiUtente["provDom"] = target.checked ? datiUtente["provRes"] : null;
    datiUtente["comuneDomicilio"] = target.checked
      ? datiUtente["comuneResidenza"]
      : null;
    datiUtente["viaDomicilio"] = target.checked
      ? datiUtente["viaResidenza"]
      : null;
    datiUtente["civicoDomicilio"] = target.checked
      ? datiUtente["civicoResidenza"]
      : null;
    datiUtente["capDomicilio"] = target.checked
      ? datiUtente["capResidenza"]
      : null;

    setProvinceDomicilio([...provinceResidenza]);
    setComuniDomicilio([...comuniResidenza]);

    setDatiUtente({ ...datiUtente });

    onChangeManaging();
  };

  const onChangeStato = async (event, type) => {
    const target = event.target;
    datiUtente[target.name] = target.value;
    datiUtente["prov" + type.substring(0, 3)] = null;
    datiUtente["comune" + type] = null;
    datiUtente["via" + type] = null;
    datiUtente["civico" + type] = null;
    datiUtente["cap" + type] = null;

    checkFlagIsPresent();

    setDatiUtente({ ...datiUtente });

    onChangeManaging();
  };

  const onChangeProvincia = async (event, type) => {
    const target = event.target;
    datiUtente[target.name] = target.value;
    datiUtente["comune" + type] = null;

    checkFlagIsPresent();

    setDatiUtente({ ...datiUtente });

    getComuni(event.target.value, "Residenza");

  }

  const onChangeValue = async (event, skipCheckFlag = false) => {
    const target = event.target;
    datiUtente[target.name] = target.value;

    if (!skipCheckFlag) {
      checkFlagIsPresent();
    }

    setDatiUtente({ ...datiUtente });

    onChangeManaging();
  };

  const onChangeManaging = () => {
    statusContext.addEvent("onbeforeunload");

    if (validate) {
      setTimeout(() => {
        setFormErrors(false, !validateTelefono(datiUtente.telefono) ? 'telefono' : null);
      }, 0);
    }

    setDirty(true);
  }

  const setFormErrors = (setFocus = true, fieldToAdd = null) => {
    const errors = utility.checkFormErrorsAndFocus(formRef, setFocus, fieldToAdd);
    setInputErrors([...errors.map(el => el.id), ...(fieldToAdd ? [fieldToAdd] : [])]);
  };

  const validateTelefono = (telefono) => {
    return regExprCellulare.test(telefono);
  };

  const sendData = (event) => {
    event.preventDefault();
    event.stopPropagation();

    setValidate(true);

    const validity = formRef.current.checkValidity();
    if (!validity || !validateTelefono(datiUtente.telefono)) {
      setFormErrors(true, !validateTelefono(datiUtente.telefono) ? 'telefono' : null);
      return;
    }

    setInputErrors([]);

    if (props.saveOnlyOnEdit && !dirty && props.dbData) {
      props.nextStep();
      return;
    }

    setInSave(true);

    datiUtente.codiceFiscale = datiUtente.codiceFiscale ?? utente.codiceFiscale;
    datiUtente.nome = datiUtente.nome ?? utente.nome;
    datiUtente.cognome = datiUtente.cognome ?? utente.cognome;
    datiUtente.prefisso = datiUtente.prefisso ?? "+39";

    const service = props.service ? props.service(props.idRichiesta, datiUtente) : userService.saveDatiUtente(datiUtente);
    service
      .then((resp) => {
        toastContext.success("Dati utente salvati con successo!");
        statusContext.removeEvent("onbeforeunload");

        setInSave(false);
        setDirty(false);

        dispatch(presaVisioneActions.setDatiUtente({ datiUtente: resp }));
        toastContext.success(props.toastMessage ?? "Dati utente aggiornati");

        if (!props.skipNavigate) {
          setTimeout(() => {
            navigation("/dashboard");
          }, 100);
        } else {
          props.propagateSave(resp);
        }
      })
      .catch((error) => {
        toastContext.error(utility.getErrorMsg(error), 12000);
        setInSave(false);
      });
  };

  const location = useLocation();
  const isDatiUtentePage = location.pathname === "/dati-utente";

  return (
    <>
      <div
        className={
          isDatiUtentePage ? "rtds-container rtds-my-12" : "rtds-my-12"
        }
      >
        <div className="rtds-mb-6 ">
          <h1 className="rtds-text-2xl rtds-font-bold">
            {props.title ?? "I miei dati"}
          </h1>
        </div>
        <div className="rtds-background-01 rtds-p-6 rtds-border rtds-border-gray-02">
          {isDatiUtentePage && (
            <AlertMessage
              message="In questa sezione devi inserire i tuoi dati personali che saranno utilizzati per richiedere il contributo 'Libri Gratis' della Regione Toscana. 
                       Ricorda di mantenere aggiornati i tuoi dati, soprattutto l'indirizzo email e il numero di cellulare, che saranno utilizzati per comunicare con te durante il processo del bando regionale."
              iconName="mini--information-circle"
              title="Attenzione!"
              classArticle="rtds-mb-6"
            />
          )}

          <div className="rtds-pb-6 rtds-space-y-4 rtds-border-b rtds-border-gray-02">
            <p>
              I campi obbligatori sono contrassegnati da un asterisco&nbsp;
              <abbr
                className="rtds-font-bold rtds-no-underline"
                title="obbligatorio"
              >
                *
              </abbr>
            </p>
          </div>

          <form
            noValidate
            ref={formRef}
            id="hasValidationForm"
            className="has-js-validation-form rtds-py-6 rtds-space-y-4"
            onSubmit={sendData}
          >
            <div className="rtds-field-row">
              <Input
                label={"Codice Fiscale"}
                id={"codiceFiscale"}
                classInput={
                  "rtds-text-sm rtds-input-placeholder rtds-uppercase"
                }
                type={"text"}
                value={
                  props.data
                    ? props.data?.codiceFiscale
                    : utente.codiceFiscale || ""
                }
                readOnly
              />

              <Input
                classDiv={"rtds-mt-3 lg:rtds-mt-0"}
                label={"Nome"}
                id={"nome"}
                classInput={"rtds-text-sm rtds-input-placeholder rtds-pr-12"}
                type={"text"}
                value={props.data ? props.data?.nome : utente.nome || ""}
                readOnly
              />

              <Input
                classDiv={"rtds-mt-3 lg:rtds-mt-0"}
                label={"Cognome"}
                id={"cognome"}
                classInput={"rtds-text-sm rtds-input-placeholder"}
                type={"text"}
                value={props.data ? props.data?.cognome : utente.cognome || ""}
                readOnly
              />
            </div>
            <div className="rtds-field-row">
              <Select
                label={"Cittadinanza"}
                required
                id={"cittadinanza"}
                inputErrors={inputErrors}
                classSelect={""}
                onChange={(event) => onChangeValue(event, true)}
                baseOption={"Seleziona Cittadinanza"}
                options={cittadinanze}
                bindValue={"cittadinanza"}
                bindKey={"cittadinanza"}
                value={datiUtente.cittadinanza || ""}
                disabled={props.disabledForm}
              />
            </div>

            <div className="rtds-horizontal-divider rtds-border-b rtds-border-gray-03 rtds-mt-3 rtds-mb-4 "></div>

            <h2 className="rtds-text-xl rtds-font-bold">Residenza</h2>

            <div className="rtds-field-row">
              <Select
                label={"Stato"}
                required
                id={"statoResidenza"}
                inputErrors={inputErrors}
                classSelect={""}
                onChange={(event) => onChangeStato(event, "Residenza")}
                baseOption={"Seleziona Stato"}
                options={stati}
                bindValue={"nome"}
                bindKey={"id"}
                value={datiUtente.statoResidenza || ""}
                disabled={props.disabledForm}
              />

              <Select
                classDiv={"rtds-mt-3 lg:rtds-mt-0"}
                label={"Provincia"}
                id={"provRes"}
                inputErrors={inputErrors}
                classSelect={""}
                onChange={(event) => onChangeProvincia(event, "Residenza")}
                baseOption={"Seleziona Provincia"}
                options={provinceResidenza}
                bindValue={"denominazione_provincia"}
                bindKey={"denominazione_provincia"}
                value={datiUtente.provRes || ""}
                required={
                  datiUtente.statoResidenza === 1 ||
                  datiUtente.statoResidenza === "1"
                }
                disabled={
                  props.disabledForm ||
                  (datiUtente.statoResidenza !== 1 &&
                    datiUtente.statoResidenza !== "1")
                }
              />

              <Select
                classDiv={"rtds-mt-3 lg:rtds-mt-0"}
                label={"Comune"}
                id={"comuneResidenza"}
                inputErrors={inputErrors}
                classSelect={""}
                onChange={(event) => onChangeValue(event)}
                baseOption={"Seleziona Comune"}
                options={comuniResidenza}
                bindValue={"denominazione"}
                bindKey={"id"}
                value={datiUtente.comuneResidenza || ""}
                required={datiUtente.provRes}
                disabled={
                  props.disabledForm ||
                  !datiUtente.provRes
                }
              />
            </div>
            <div className="rtds-field-row">
              <Input
                label={"Via"}
                id={"viaResidenza"}
                inputErrors={inputErrors}
                classInput={"rtds-text-sm rtds-input-placeholder"}
                type={"text"}
                onChange={(event) => onChangeValue(event)}
                value={datiUtente.viaResidenza || ""}
                required={
                  datiUtente.statoResidenza === 1 ||
                  datiUtente.statoResidenza === "1"
                }
                disabled={
                  props.disabledForm ||
                  (datiUtente.statoResidenza !== 1 &&
                    datiUtente.statoResidenza !== "1")
                }
                maxLength={100}
              />

              <Input
                classDiv={"rtds-mt-3 lg:rtds-mt-0"}
                label={"Numero civico"}
                id={"civicoResidenza"}
                inputErrors={inputErrors}
                classInput={"rtds-text-sm rtds-input-placeholder rtds-pr-12"}
                type={"text"}
                onChange={(event) => onChangeValue(event)}
                value={datiUtente.civicoResidenza || ""}
                required={
                  datiUtente.statoResidenza === 1 ||
                  datiUtente.statoResidenza === "1"
                }
                disabled={
                  props.disabledForm ||
                  (datiUtente.statoResidenza !== 1 &&
                    datiUtente.statoResidenza !== "1")
                }
                maxLength={10}
              />

              <Input
                classDiv={"rtds-mt-3 lg:rtds-mt-0"}
                label={"CAP"}
                id={"capResidenza"}
                inputErrors={inputErrors}
                classInput={"rtds-text-sm rtds-input-placeholder"}
                type={"text"}
                onChange={(event) => onChangeValue(event)}
                value={datiUtente.capResidenza || ""}
                required={
                  datiUtente.statoResidenza === 1 ||
                  datiUtente.statoResidenza === "1"
                }
                disabled={
                  props.disabledForm ||
                  (datiUtente.statoResidenza !== 1 &&
                    datiUtente.statoResidenza !== "1")
                }
                minLength={5}
                maxLength={5}
                mask={masks.maskCap}
              />
            </div>

            <div className="rtds-horizontal-divider rtds-border-b rtds-border-gray-03 rtds-mt-3 rtds-mb-4 "></div>

            <h2 className="rtds-text-xl rtds-font-bold">Domicilio</h2>

            <div className="rtds-field-row">
              <Checkbox
                classDiv={"rtds-input-checkbox rtds-input--lg"}
                label={
                  "Selezionare se i dati residenziali coincidono con quelli del domiclio"
                }
                id={"domicilioComeResidenza"}
                inputErrors={inputErrors}
                classInput={""}
                onChange={(event) =>
                  onChangeFlagDomicilioAsResidenza(event, "checked")
                }
                checked={datiUtente.domicilioComeResidenza || false}
                disabled={props.disabledForm || !stati}
              />
            </div>

            <div className="rtds-field-row">
              <Select
                label={"Stato"}
                required
                id={"statoDomicilio"}
                inputErrors={inputErrors}
                classSelect={""}
                onChange={(event) => onChangeStato(event, "Domicilio")}
                baseOption={"Seleziona Stato"}
                options={stati}
                bindValue={"nome"}
                bindKey={"id"}
                value={datiUtente.statoDomicilio || ""}
                disabled={
                  props.disabledForm || datiUtente.domicilioComeResidenza
                }
              />

              <Select
                classDiv={"rtds-mt-3 lg:rtds-mt-0"}
                label={"Provincia"}
                id={"provDom"}
                inputErrors={inputErrors}
                classSelect={""}
                onChange={(event) => {
                  onChangeValue(event);
                  getComuni(event.target.value, "Domicilio");
                }}
                baseOption={"Seleziona Provincia"}
                options={provinceDomicilio}
                bindValue={"denominazione_provincia"}
                bindKey={"denominazione_provincia"}
                value={datiUtente.provDom || ""}
                required={
                  datiUtente.statoDomicilio === 1 ||
                  datiUtente.statoDomicilio === "1"
                }
                disabled={
                  props.disabledForm ||
                  datiUtente.domicilioComeResidenza ||
                  (datiUtente.statoDomicilio !== 1 &&
                    datiUtente.statoDomicilio !== "1")
                }
              />

              <Select
                classDiv={"rtds-mt-3 lg:rtds-mt-0"}
                label={"Comune"}
                id={"comuneDomicilio"}
                inputErrors={inputErrors}
                classSelect={""}
                onChange={(event) => onChangeValue(event)}
                baseOption={"Seleziona Comune"}
                options={comuniDomicilio}
                bindValue={"denominazione"}
                bindKey={"id"}
                value={datiUtente.comuneDomicilio || ""}
                required={
                  datiUtente.provDom ||
                  datiUtente.statoDomicilio === 1 ||
                  datiUtente.statoDomicilio === "1"
                }
                disabled={
                  props.disabledForm ||
                  datiUtente.domicilioComeResidenza ||
                  !datiUtente.provDom
                }
              />
            </div>
            <div className="rtds-field-row">
              <Input
                label={"Via"}
                id={"viaDomicilio"}
                inputErrors={inputErrors}
                classInput={"rtds-text-sm rtds-input-placeholder"}
                type={"text"}
                onChange={(event) => onChangeValue(event)}
                value={datiUtente.viaDomicilio || ""}
                required={
                  datiUtente.statoDomicilio === 1 ||
                  datiUtente.statoDomicilio === "1"
                }
                disabled={
                  props.disabledForm ||
                  datiUtente.domicilioComeResidenza ||
                  (datiUtente.statoDomicilio !== 1 &&
                    datiUtente.statoDomicilio !== "1")
                }
                maxLength={100}
              />

              <Input
                classDiv={"rtds-mt-3 lg:rtds-mt-0"}
                label={"Numero civico"}
                id={"civicoDomicilio"}
                inputErrors={inputErrors}
                classInput={"rtds-text-sm rtds-input-placeholder rtds-pr-12"}
                type={"text"}
                onChange={(event) => onChangeValue(event)}
                value={datiUtente.civicoDomicilio || ""}
                required={
                  datiUtente.statoDomicilio === 1 ||
                  datiUtente.statoDomicilio === "1"
                }
                disabled={
                  props.disabledForm ||
                  datiUtente.domicilioComeResidenza ||
                  (datiUtente.statoDomicilio !== 1 &&
                    datiUtente.statoDomicilio !== "1")
                }
                maxLength={10}
              />

              <Input
                classDiv={"rtds-mt-3 lg:rtds-mt-0"}
                label={"CAP"}
                id={"capDomicilio"}
                inputErrors={inputErrors}
                classInput={"rtds-text-sm rtds-input-placeholder"}
                type={"text"}
                onChange={(event) => onChangeValue(event)}
                value={datiUtente.capDomicilio || ""}
                required={
                  datiUtente.statoDomicilio === 1 ||
                  datiUtente.statoDomicilio === "1"
                }
                disabled={
                  props.disabledForm ||
                  datiUtente.domicilioComeResidenza ||
                  (datiUtente.statoDomicilio !== 1 &&
                    datiUtente.statoDomicilio !== "1")
                }
                minLength={5}
                maxLength={5}
                mask={masks.maskCap}
              />
            </div>

            <div className="rtds-horizontal-divider rtds-border-b rtds-border-gray-03 rtds-mt-3 rtds-mb-4 "></div>

            <div className="rtds-field-row">
              <Input
                label={"Email"}
                id={"email"}
                inputErrors={inputErrors}
                classInput={"rtds-text-sm rtds-input-placeholder"}
                type={"email"}
                onChange={(event) => onChangeValue(event, true)}
                value={datiUtente.email || ""}
                required
                disabled={props.disabledForm}
                errorPattern={"Formato non valido"}
                pattern={regExprEmail}
              />

              <Input
                classDiv={"rtds-mt-3 lg:rtds-mt-0"}
                label={"PEC"}
                id={"pec"}
                inputErrors={inputErrors}
                classInput={"rtds-text-sm rtds-input-placeholder rtds-pr-12"}
                type={"email"}
                onChange={(event) => onChangeValue(event, true)}
                value={datiUtente.pec || ""}
                disabled={props.disabledForm}
                errorPattern={"Formato non valido"}
                pattern={regExprEmail}
              />

              <Select
                classDiv={"rtds-mt-3 lg:rtds-mt-0"}
                label={"Prefisso"}
                id={"prefisso"}
                inputErrors={inputErrors}
                classSelect={""}
                onChange={(event) => onChangeValue(event, true)}
                baseOption={"Seleziona prefisso"}
                options={prefixes.map((prefix) => ({ key: prefix }))}
                bindValue={"key"}
                bindKey={"key"}
                value={datiUtente.prefisso || "+39"}
                required
                disabled
              />
              <Input
                classDiv={"rtds-mt-3 lg:rtds-mt-0"}
                label={"Cellulare"}
                id={"telefono"}
                inputErrors={inputErrors}
                classInput={"rtds-text-sm rtds-input-placeholder"}
                type={"tel"}
                pattern={regExprCellulare.toString()}
                errorPattern={"Formato non valido"}
                onChange={(event) => onChangeValue(event, true)}
                value={datiUtente.telefono || ""}
                required
                minLength={10}
                maxLength={10}
                disabled={props.disabledForm}
                mask={masks.maskTel}
              />
            </div>

            <AlertMessage
              message={
                <>
                  {!isDatiUtentePage && (
                    <p className="rtds-mb-3">
                      Modificando i dati del richiedente essi saranno aggiornati
                      anche nella sezione 'I miei dati'.
                    </p>
                  )}
                  <p>
                    Il numero di cellulare indicato potrà essere utilizzato
                    anche per invio di comunicazioni via SMS.
                  </p>
                </>
              }
              iconName="mini--information-circle"
              title="Attenzione!"
            />

            <div className="rtds-border-gray-02 rtds-border-b rtds-border-t rtds-p-3 rtds-flex sm:rtds-justify-end rtds-justify-center">
              <div className="rtds-form-actions">
                <div
                  className="rtds-inline-flex rtds-gap-1"
                  role="group"
                  aria-label="Salva"
                >
                  <button
                    type="submit"
                    className="rtds-btn rtds-btn--icon-right rtds-group/button rtds-btn--primary rtds-form-submit "
                    disabled={
                      inSave ||
                      !utente?.codiceFiscale ||
                      provinceResidenza?.length <= 0 ||
                      stati?.length <= 0
                    }
                  >
                    {/* <svg
                      className="rtds-icon rtds-fill-current rtds-w-6 rtds-h-6 group-hover/button:-rtds-translate-x-1"
                      aria-hidden="true"
                      focusable="false"
                      role="img"
                    >
                      <use
                        xlinkHref={`${process.env.PUBLIC_URL}/icons.svg#${"solid--pencil-square"}`}
                      />
                    </svg>{" "} */}
                    {props.salvaLabel ?? "Salva"}
                    {inSave ||
                    !utente?.codiceFiscale ||
                    provinceResidenza?.length <= 0 ||
                    stati?.length <= 0 ? (
                      <>
                        <svg
                          className="rtds-icon rtds-fill-current rtds-w-4 rtds-h-4 rtds-animate-spin md:rtds-w-5 md:rtds-h-5 lg:rtds-w-6 lg:rtds-h-6"
                          aria-hidden="true"
                          focusable="false"
                          role="img"
                        >
                          <use
                            xlinkHref={`${process.env.PUBLIC_URL}/icons.svg#spinner`}
                          />
                        </svg>
                        <span className="rtds-sr-only">Caricamento...</span>
                      </>
                    ) : (
                      <>
                        <svg
                          className="rtds-icon rtds-fill-current rtds-w-4 rtds-h-4 md:rtds-w-5 md:rtds-h-5 lg:rtds-w-6 lg:rtds-h-6 group-hover/button:rtds-translate-x-1"
                          aria-hidden="true"
                          focusable="false"
                          role="img"
                        >
                          <use
                            xlinkHref={`${process.env.PUBLIC_URL}/icons.svg#mini--chevron-right`}
                          />
                        </svg>
                      </>
                    )}
                  </button>

                  {props.children}
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
    </>
  );
});

export default DatiUtente;
